"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Query_1 = require("./Query");

var BaseEntityQuery_1 = require("./BaseEntityQuery");

var EntitiesQuery = function (_super) {
  __extends(EntitiesQuery, _super);

  function EntitiesQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EntitiesQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        entityConditional = _a.entityConditional,
        entitiesOptions = _a.entitiesOptions,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    var childQuery = (entitiesOptions || {}).childQuery;
    return __assign({
      entityConditional: entityConditional,
      childQuery: childQuery
    }, options.entities || {});
  };

  EntitiesQuery.prototype.getRawValue = function (executionOptions) {
    var _a;

    var entities = this.getEntities(executionOptions);
    var results = [];

    if (entities && entities.length > 0) {
      var childQuery = this.options.childQuery;

      var options = __assign({}, this.queryOptions);

      if (childQuery) {
        options = childQuery;

        if (!childQuery.entityType) {
          var entityType = entities[0].type;
          options.entityType = entityType;
        }

        var query = new Query_1.Query(options, this.translationHelper);

        for (var _i = 0, entities_1 = entities; _i < entities_1.length; _i++) {
          var entity = entities_1[_i];
          var overrideExecutionOptions = {
            context: {
              entityByType: (_a = {}, _a[options.entityType] = entity, _a)
            }
          };
          var workingExecutionOptions = query.mergeExecutionOptions(executionOptions, overrideExecutionOptions || {});
          var result = query.execute(workingExecutionOptions);

          if (result) {
            results.push(result);
          }
        }
      } else {
        // Default to return whole entity if no childQuery is defined.
        return entities;
      }
    }

    return results;
  };

  return EntitiesQuery;
}(BaseEntityQuery_1.BaseEntityQuery);

exports.EntitiesQuery = EntitiesQuery;